export default __webpack_public_path__ + "static/media/manage-meeting-rooms-oq-logo.e64f126c.png";